<template>
  <main class="model-profile">
    <div class="model-profile__wrapper">
      <!-- carousel for desktop -->
      <div class="model-profile__carousel">
        <transition-group tag="div" class="slides-wrapper" :name="desktopTransitionName">
          <template v-for="(slide, index) in model.images">
            <div
              class="model-profile__slide model-profile__slide_desktop model-profile__slide_whole"
              v-if="slide.type == 'whole'"
              :key="slide.id"
              v-show="index == curDesktopSlideIndex"
            >
              <img class="model-profile__image" :src="slide.images[0].url" >
            </div>
            <div
              class="model-profile__slide model-profile__slide_desktop model-profile__slide_half"
              v-else
              :key="slide.id"
              v-show="index == curDesktopSlideIndex"
            >
              <img
                v-show="slide.images[0].url"
                class="model-profile__image model-profile__image_left"
                :src="slide.images[0].url" />
              <img 
                v-show="slide.images[1].url"
                class="model-profile__image model-profile__image_right"
                :src="slide.images[1].url" />
            </div>
          </template>
          <div key="controls" class="carousel-controls">
            <div @click="slideLeft('desktop')"></div>
            <div @click="slideRight('desktop')"></div>
          </div>
        </transition-group>
      </div>
      <div class="model-profile__info">
        <span class="model-profile__name">{{ model.name }}</span>
        <ul class="model-information">
          <li class="model-information__property">height<span class="model-information__value">{{ model.height }}</span></li>
          <li class="model-information__property">bust<span class="model-information__value">{{ model.bust }}</span></li>
          <li class="model-information__property">waist<span class="model-information__value">{{ model.waist }}</span></li>
          <li class="model-information__property">hips<span class="model-information__value">{{ model.hips }}</span></li>
          <li class="model-information__property">shoes<span class="model-information__value">{{model.shoes}}</span></li>
          <li class="model-information__property">hair<span class="model-information__value">{{ model.hair }}</span></li>
          <li class="model-information__property">eyes<span class="model-information__value">{{ model.eyes }}</span></li>
          <li class="model-information__property"><a :href="model.instagram" target="_blank" class="model-information__value">instagram</a></li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import { apiGetModel } from '../utils/api'

export default {
  name: 'ModelProfile',
  data() {
    return {
      model: {
        name: '',
        height: '',
        bust: '',
        waist: '',
        hips: '',
        shoes: '',
        hair: '',
        eyes: '',
        instagram: '',
        preview: null,
        images: []
      },
      curMobileSlideIndex: 0,
      curDesktopSlideIndex: 0,
      desktopTransitionName: 'fade-left',
    }
  },
  async mounted() {
    const modelId = this.$route.query.id
    const gender = this.$route.params.gender == 'men' ? 'male' : 'female'
    let modelIndex
    if (gender == 'male') {
      modelIndex = this.$store.state.clientMaleModels.findIndex((el) => el.id == modelId)
    } else {
      modelIndex = this.$store.state.clientFemaleModels.findIndex((el) => el.id == modelId)
    }
    if (modelIndex != -1) {
      // load model from store
      if (gender == 'male') {
        this.model = this.$store.state.clientMaleModels[modelIndex]
      } else {
        this.model = this.$store.state.clientFemaleModels[modelIndex]
      }
    } else {
      // load model from firestore
      try {
        this.model = await apiGetModel(modelId)
      } catch(e) {
        console.error(e.message)
        this.$router.push({ name: 'AllModels' })
      }
    }
  },
  methods: {
    slideLeft(carousel) {
      if (carousel == 'desktop') {
        this.desktopTransitionName = 'fade-right'
        this.curDesktopSlideIndex == 0 
          ? this.curDesktopSlideIndex = this.model.images.length - 1 
          : this.curDesktopSlideIndex = this.curDesktopSlideIndex - 1
      }
    },
    slideRight(carousel) {
      if (carousel == 'desktop') {
        this.desktopTransitionName = 'fade-left'
        this.curDesktopSlideIndex == this.model.images.length - 1 
          ? this.curDesktopSlideIndex = 0
          : this.curDesktopSlideIndex = this.curDesktopSlideIndex + 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";

.model-profile {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 45px 100px 0;
  overflow-x: hidden;
  &__wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    max-width: 100%;
    height: 100%;
  }
  &__carousel {
    display: grid;
    position: relative;
    height: 70vh;
    max-width: 100%;
    margin-bottom: 20px;
    overflow-x: visible;
  }
  &__slide {
    display: flex;
    justify-content: center;
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    width: 100%;
    max-width: 100%;
    overflow-x: visible;
    &_desktop {
      height: 70vh;
    }
    &_half > img:first-child {
      margin-right: 10px;
    }
    &_half > img {
      max-width: 50%;
    }
    &_whole > img {
      max-width: 100%;
    }
  }
  &__image {
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    &_left {
      justify-self: right;
    }
    &_right {
      justify-self: left;
    }
  }

  &__info {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    grid-row: 2 / 3;
  }
  &__name {
    @include fonts.ap-reg;
    font-size: 20px;
    margin-right: 12px;
    text-transform: uppercase;
  }
}

.carousel-controls {
  display: grid;
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  height: 100%;
  grid-template-columns: 1fr 1fr;
  z-index: 2;
  cursor: pointer;
}

.slides-wrapper {
  position: relative;
  display: grid;
  height: 100%;
}

.model-information {
  &__property {
    @include fonts.mo-reg;
    display: inline-block;
    font-size: 10px;
    text-transform: uppercase;
    &:not(:last-child) {
      margin-right: 12px;
    }
    &>span {
      margin-left: 5px;
    }
  }
  &__value {
    @include fonts.mo-med;
    font-size: 10px;
    text-transform: uppercase;
    color: #000;
    text-decoration: none;
  }
}

@media screen and (max-width: 1024px) and (orientation: portrait) {
  .model-profile {
    &__wrapper {
      flex-direction: column-reverse;
      height: auto;
    }
    &__carousel {
      height: auto;
      overflow: visible;
    }
    &__slide {
      overflow: visible;
      display: flex !important;
      height: auto;
      flex-direction: column;
      grid-column: auto;
      grid-row: auto;
      & > img:not(:last-child) {
        margin-bottom: 30px;
      }
      &_half > img {
        max-width: 100%;
      }
    }
    &__image {
      position: relative;
      width: 100%;
      height: auto;
    }
    &__info {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-bottom: 30px;
    }
    &__name {
      // font-size: 18px;
      margin-bottom: 8px;
    }
  }

  .slides-wrapper {
    row-gap: 30px;
    height: auto;
  }

  .model-information {
    line-height: 18px;
  }

  .carousel-controls {
    display: none;
  }
}
@media screen and (max-width: 1024px) and (orientation: landscape) {
  .model-profile {
    padding: 15px 50px 0;
    &__info {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
    &__name {
      font-size: 18px;
      margin-bottom: 8px;
    }
  }
  .model-information {
    line-height: 18px;
  }
}
@media screen and (max-width: 767px) {
  .model-profile {
    padding: 30px 12px 0;
    &__wrapper {
      flex-direction: column-reverse;
      height: auto;
    }
    &__carousel {
      height: auto;
      overflow: visible;
    }
    &__slide {
      overflow: visible;
      display: flex !important;
      height: auto;
      flex-direction: column;
      grid-column: auto;
      grid-row: auto;
      & > img:not(:last-child) {
        margin-bottom: 30px;
      }
      &_half > img {
        max-width: 100%;
      }
    }
    &__image {
      position: relative;
      width: 100%;
      height: auto;
    }
    &__name {
      font-size: 18px;
    }
  }

  .slides-wrapper {
    row-gap: 30px;
    height: auto;
  }
}

// slides animation
.fade-left-enter {
  opacity: 0;
  transform: translateX(400px);
}

.fade-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.fade-left-enter-active {
  transition: all 400ms ease;
}

.fade-left-leave {
  opacity: 1;
  transform: translateX(0);
}

.fade-left-leave-to {
  opacity: 0;
  transform: translateX(-400px);
}

.fade-left-leave-active {
  transition: all 400ms ease;
}

.fade-right-enter {
  opacity: 0;
  transform: translateX(-400px);
}

.fade-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.fade-right-enter-active {
  transition: all 400ms ease;
}

.fade-right-leave {
  opacity: 1;
  transform: translateX(0);
}

.fade-right-leave-to {
  opacity: 0;
  transform: translateX(+400px);
}

.fade-right-leave-active {
  transition: all 400ms ease;
}
</style>